<template>

    <v-dropdown v-if="user.features.agency && user.agency"
        :label="user.agency.name"
        :items="items"
        :menu-position="'br'"
        :show-selected="false"
        :size="size"
        @change="onChange"
    />

</template>

<script>

export default {

    props: {
        size: {
            type: String,
            default: 'sm',
        },
    },

    computed: {

        items() {
            return [
                {
                    key: 'agency.projects',
                    value: this.$t('labels.projects'),
                    icon: 'fas fa-layer-group',
                },
                {
                    key: 'agency.clients',
                    value: this.$t('labels.clients'),
                    icon: 'fas fa-people-group',
                },
                {
                    key: 'agency.team',
                    value: this.$t('labels.team'),
                    icon: 'fas fa-user-group',
                },
            ];
        },

    },

    methods: {

        onChange(e) {
            this.$router.push({ name: e.key, 'params': { 'id': this.user.agency.id } }).catch(() => {});
        },

    },

}

</script>
